module.exports = "/assets/dist/images/OculusGo.png?cb25543ab2c23226a5320a5ec179dfee";